export const initialState = {
  searchResult: null,
  searchParams: {
    customerId: null,
    createdFromDate: null,
    createdToDate: null,
    approvedFromDate: null,
    approvedToDate: null,
    isQuote: true,
    isSubmitted: false,
    isApproved: false,
    isCompleted: false,
    isExpired: false,
    userId: null,
    lastUpdate: '',
  },
  radioButtonValue:'radioButtonWithMultiFilter',
  quoteDetail: null,
  quoteItems: null,
  searchText: '',
  totalRecords: 0,
};
